'use client';

import { useEffect } from 'react';
import { domains } from '@lib/constants/domains';
import { HOSTING_ENV } from '@lib/config';

const gaName = 'ga_G9X5JR3N67_state';

const Hotjar = () => {
  const handleHotjar = () => {
    const hotjarEnable = (sessionStorage.getItem(gaName) || 'true') === 'true';
    if (!hotjarEnable || hotjarEnable == "false") {
      return;
    }

    const currentDomain = window.location.hostname;

    let hjid = '5123493';

    if (currentDomain === domains.prod || HOSTING_ENV?.includes('prod'))
      hjid = '5123230';
    else if (currentDomain === domains.qa || HOSTING_ENV?.includes('qa'))
      hjid = '5123495';

    // Insert Hotjar tracking code into the head section
    const script = document.createElement('script');
    script.innerHTML = `
            (function(h,o,t,j,a,r){
                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                h._hjSettings={hjid:${hjid},hjsv:6};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `;
    document.head.appendChild(script);

    return () => {
      // Cleanup if necessary
      document.head.removeChild(script);
    };
  }

  useEffect(() => {
    window.addEventListener('storage', (e) => {
      handleHotjar();
    })
       
    handleHotjar();
  }, []);

  return null;
};

export default Hotjar;
